<script>
import moment from "@/utils/moment";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState, mapActions, mapGetters } from "vuex";
import { event } from "vue-analytics";

import Modal from "@/components/_Shared/Modal";
import dateMixin from "@/mixins/dateMixin";

function daysOfPrecedenceFrom(event) {
  return moment(event).diff(moment(), "days") + 1;
}

export default {
  mixins: [dateMixin],
  components: {
    swiper,
    swiperSlide,
    Modal
  },

  props: {
    title: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          530: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
          },
          730: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
      },
      professional: false
    };
  },

  computed: {
    ...mapState("professionalsSuggestion", [
      "availableEvents",
      "selectedEvent",
      "loader"
    ]),
    ...mapGetters("newOrder", ["labelDuration", "duration"]),
    ...mapState("newOrder", ["day", "address", "starts_at"])
  },

  methods: {
    ...mapActions("professionalsSuggestion", [
      "setAvailableEvents",
      "setEvent"
    ]),
    ...mapActions("newOrder", ["setDay", "setToBe"]),

    selectAvailableEvent(event) {
      this.sendEvent(event);
      this.setEvent(event);
      this.setToBe("schedule");
      this.$emit("daySelected", new Date(event.starts_at));
      this.setAvailableEvents(null);
    },
    sendEvent(suggestion) {
      let newOrderDay = moment(this.day).format("DD/MM/Y");
      let suggestionDay = moment(suggestion).format("DD/MM/Y");

      event(
        "cliente",
        "click",
        `Compra:diaespecifico:semprofissionaldisponivel:sugestaoescolhida:bairro=${
          this.address.district.display_name
        }:cidade=${
          this.address.district.city.display_name
        }:diasemprofissional=${newOrderDay}:horainicial=${
          this.starts_at
        }:duracao=${this.duration}:diasdeantecedencia=${daysOfPrecedenceFrom(
          newOrderDay
        )}:diasugerido=${suggestionDay}:horainicial=${moment(
          suggestion.starts_at
        ).format("HH:mm")}:duracao=${suggestion.duration /
          60}:diasdeantecedencia=${daysOfPrecedenceFrom(suggestionDay)}`
      );
    }
  }
};
</script>

<template>

  <div class="mt-30">
    <div v-if="title" class="section-title">
      {{title}}
      <hr />
    </div>

    <div v-if="loader" class="swiper-container">
      <div>Buscando sugestão de horários</div>
      <img src="/static/loader.svg" width="150px" />
    </div>

    <div
        class="style-info"
        v-else-if="!loader && (availableEvents === null || !availableEvents.length)"
      >Não encontramos profissionais disponíveis próximo a data escolhida.</div>

    <div v-else>
      <div class="style-info">Selecione um dos horários sugeridos para ajustar a duração da limpeza</div>

      <swiper :options="swiperOption">
        <swiper-slide v-for="(event, index) in availableEvents" :key="index+'-event'">
          <div
            class="event"
            @click="selectAvailableEvent(event)"
            :class="{selected: selectedEvent === event}"
          >
            <b class="text-purple">{{event.starts_at | formatDate('DD/MM')}}</b>
            <b>
              <small class="text-purple">{{event.starts_at | formatDate('dddd')}}</small>
            </b>
            <small>
              das
              {{event.starts_at | formatDate('HH[hrs]')}}
              às
              {{event.ends_at | formatDate('HH[hrs]')}}
            </small>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev prev" slot="button-prev"></div>
        <div class="swiper-button-next next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<style scoped>
.section {
  text-align: center;
}

.row {
  justify-content: center;
}

.style-info {
  font-size: 14px;
  text-align: center;
}

.swiper-container {
  width: 100%;
  text-align: center;
}

.event {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 2px solid #eee;
  border-radius: 4px;
  margin: 10px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.event.selected {
  border-color: var(--purple);
}

.swiper-button-prev {
  background-image: url("/static/arrow-prev.svg") !important;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0 !important;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0 !important;
}

.swiper-button-next {
  background-image: url("/static/arrow-next.svg") !important;
}

@media (max-width: 720px) {
  .section {
    width: 400px;
  }
}

@media (max-width: 630px) {
  .section {
    width: 250px;
  }
  .event {
    width: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/ProfessionalsSuggestion.vue